import React from 'react';
import {
    Box,
    FormControl,
    MenuItem,
    Select,
    Slider,
    Rating,
    Typography,
    useTheme
} from '@mui/material';

interface StoriesHeaderControlsDiscoveryProps {
    sortDirection: 'ASC' | 'DESC';
    setSortDirection: (dir: 'ASC' | 'DESC') => void;
    sliderValue: [number, number];
    setSliderValue: (value: [number, number]) => void;
    setDebouncedSliderValue: (value: [number, number]) => void;
}

export default function StoriesHeaderControlsDiscovery({
                                                           sortDirection,
                                                           setSortDirection,
                                                           sliderValue,
                                                           setSliderValue,
                                                           setDebouncedSliderValue
                                                       }: StoriesHeaderControlsDiscoveryProps) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: 2,
                alignItems: { xs: 'stretch', sm: 'center' },
                justifyContent: 'space-between',
                width: '100%',
            }}
        >
            <Box
                display="flex"
                flexDirection={{ xs: 'column', sm: 'row' }}
                alignItems={{ xs: 'stretch', sm: 'center' }}
                gap={{ xs: 1, sm: 2 }}
                flex={1}
                minWidth={0}
            >
                <Typography
                    variant="body1"
                    sx={{
                        whiteSpace: 'nowrap',
                        minWidth: 'fit-content',
                    }}
                >
                    Filter:
                </Typography>

                <Box
                    display="flex"
                    flexDirection={{ xs: 'column', sm: 'row' }}
                    alignItems={{ xs: 'stretch', sm: 'center' }}
                    gap={{ xs: 1, sm: 2 }}
                    flexGrow={1}
                >
                    <Rating value={sliderValue[0]} readOnly precision={0.5} size="small" />
                    <Slider
                        value={sliderValue}
                        onChange={(_, newValue) => setSliderValue(newValue as [number, number])}
                        onChangeCommitted={(_, newValue) => setDebouncedSliderValue(newValue as [number, number])}
                        min={0.5}
                        max={5}
                        step={0.5}
                        valueLabelDisplay="auto"
                        sx={{
                            flexGrow: 1,
                            maxWidth: { xs: 120, sm: 200 },
                        }}
                    />
                    <Rating value={sliderValue[1]} readOnly precision={0.5} size="small" />
                </Box>
            </Box>


            <Box
                display="flex"
                justifyContent="flex-end"
                alignSelf={{ xs: 'flex-end', sm: 'auto' }} // <== critical line
                mt={{ xs: 1, sm: 0 }}
            >
                <FormControl size="small" sx={{ minWidth: 160 }}>
                    <Select
                        value={sortDirection}
                        onChange={(e) => setSortDirection(e.target.value as 'ASC' | 'DESC')}
                        sx={{
                            '.MuiSelect-select.MuiSelect-outlined': {
                                py: '9px',
                            },
                            '.MuiOutlinedInput-notchedOutline': {
                                borderColor: theme.palette.divider,
                            },
                        }}
                    >
                        <MenuItem value="DESC">Neueste</MenuItem>
                        <MenuItem value="ASC">Älteste</MenuItem>
                    </Select>
                </FormControl>
            </Box>
        </Box>
    );
}